import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Departments',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'organizations',
                },
              },
              subqueries: {
                organizations: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdc',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdc',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdcDensity',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdcDensity',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '=': [
                          {
                            '@_': ['parent', 'id'],
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'orgEntityId',
                              },
                            },
                          },
                        ],
                      },
                      {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      {
                        not: {
                          '=': [
                            {
                              '@': 'projects',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        not: {
                          '=': [
                            {
                              '@': 'rooms',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'asf',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'asf',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'effectiveRecovery',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'effectiveRecovery',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'shouldAnalyze',
                                  },
                                },
                                true,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '@.': '!should_analyze',
                                },
                                true,
                              ],
                            },
                          ],
                          true,
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'dim::!org',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          asf: {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          tdc: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          code: {
                            '{}': {
                              value: {
                                '@.': '!code',
                              },
                            },
                          },
                          mtdc: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          name: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                          mtdcAvg: {
                            '{}': {
                              value: {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdcInLastThreeYears',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  3,
                                ],
                              },
                            },
                          },
                          projects: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'projects',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          totalSqft: {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'sqft',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          tdcDensity: {
                            '{}': {
                              value: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '??': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            1,
                                          ],
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'projects',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'tdc',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                  ],
                                  {
                                    '/': [
                                      {
                                        '??': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projects',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'tdc',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          0,
                                        ],
                                      },
                                      {
                                        '??': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          1,
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                          mtdcDensity: {
                            '{}': {
                              value: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '??': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            1,
                                          ],
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'projects',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdc',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                  ],
                                  {
                                    '/': [
                                      {
                                        '??': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projects',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'mtdc',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          0,
                                        ],
                                      },
                                      {
                                        '??': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          1,
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                          utilization: {
                            '{}': {
                              value: {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'sqft',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          },
                          mtdcAvgDensity: {
                            '{}': {
                              value: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '??': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            1,
                                          ],
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'projects',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdc',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                  ],
                                  {
                                    '/': [
                                      {
                                        '??': [
                                          {
                                            '/': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': 'projects',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'mtdcInLastThreeYears',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              3,
                                            ],
                                          },
                                          0,
                                        ],
                                      },
                                      {
                                        '??': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          1,
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      overflowActions: {
                        '[]': [
                          {
                            '{}': {
                              icon: 'atn-icon atn-link',
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              orgEntityId: {
                                                '@_': 'id',
                                              },
                                              orgRecordId: {
                                                '@.': '!id',
                                              },
                                            },
                                          },
                                          navigationId: 'explore',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        ],
                      },
                    },
                  },
                  subqueries: {
                    rooms: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                      },
                      using: 'orgSpace',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '@^': {
                                      '``': {
                                        '@$': 'spaceEntityId',
                                      },
                                    },
                                  },
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'piRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '!=': [
                                  {
                                    '@': 'pis',
                                  },
                                  null,
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '{}': {
                          asf: {
                            '*': [
                              {
                                '@.': '!sqft',
                              },
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '*': [
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'value',
                                              ],
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'allowable',
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'value',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          sqft: {
                            '@.': '!sqft',
                          },
                        },
                      },
                      subqueries: {
                        pis: {
                          ref: {
                            attr: 'attr:ent#!person_space#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            '=': [
                              {
                                '@.': [
                                  '!personnel',
                                  {
                                    ref: {
                                      entity: '!employee',
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                            ],
                          },
                          target: 'ent:!person_space:!entry',
                          selection: {
                            '@.': [
                              '!personnel',
                              {
                                ref: {
                                  entity: '!employee',
                                },
                              },
                            ],
                          },
                        },
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            '!=': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '{}': {
                              value: {
                                '@.': '!weight',
                              },
                              allowable: {
                                if: [
                                  [
                                    {
                                      '!=': [
                                        {
                                          '@': 'funcIdCat',
                                        },
                                        null,
                                      ],
                                    },
                                    1,
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            funcIdCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    orgSpace: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!org',
                        inherit: '-',
                      },
                      target: 'ent:!org_space:!entry',
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!org',
                        inherit: '-',
                      },
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': '!research_type_wfuhs',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            not: {
                              '=': [
                                {
                                  '@': 'projectPiAssignments',
                                },
                                null,
                              ],
                            },
                          },
                        ],
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '{}': {
                          tdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          mtdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          mtdcInLastThreeYears: {
                            '+': {
                              '@': 'projectGlExpensesInMtdcInLastThreeYears',
                            },
                          },
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              tdcAmount: {
                                '@.': '!amount',
                              },
                              idcrAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@.': [
                                            '!acct',
                                            {
                                              ref: {
                                                entity: '!acct',
                                              },
                                            },
                                          ],
                                        },
                                        '?7631013',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '@': 'isInMtdc',
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                          },
                        },
                        projectPiAssignments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          filter: {
                            and: [
                              {
                                not: {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'piRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'piRecordId',
                                    },
                                  },
                                  {
                                    '@.': [
                                      '!pi',
                                      {
                                        ref: {
                                          entity: '!employee',
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          target: 'ent:!proj_pis:!entry',
                        },
                        projectPiDepartments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          target: 'ent:!proj_pis:!entry',
                          selection: {
                            '@': 'piDept',
                          },
                          subqueries: {
                            piDept: {
                              ref: {
                                attr: 'attr:ent#!proj_pis#!entry:!pi',
                              },
                              target: 'ent:!personnel:!employee',
                              selection: {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: '!dept',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                        projectGlExpensesInMtdcInLastThreeYears: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          filter: {
                            '@': 'isInMtdc',
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2024',
                              },
                              start: {
                                $date: '1/1/2022',
                              },
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdc',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '<=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdc',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcMax',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '<=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcDensityMax',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    '=': [
                      {
                        '@_': ['parent', 'id'],
                      },
                      {
                        '`': {
                          '``': {
                            '@$': 'orgEntityId',
                          },
                        },
                      },
                    ],
                  },
                  {
                    '=': [
                      {
                        '@^': 'parent',
                      },
                      {
                        '``': {
                          '@$': 'orgRecordId',
                        },
                      },
                    ],
                  },
                  {
                    not: {
                      '=': [
                        {
                          '@': 'projects',
                        },
                        null,
                      ],
                    },
                  },
                  {
                    not: {
                      '=': [
                        {
                          '@': 'rooms',
                        },
                        null,
                      ],
                    },
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'asf',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '<=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'asf',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'asfMax',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '<=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMax',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '``': {
                                '@$': 'shouldAnalyze',
                              },
                            },
                            true,
                          ],
                        },
                        {
                          '=': [
                            {
                              '@.': '!should_analyze',
                            },
                            true,
                          ],
                        },
                      ],
                      true,
                    ],
                  },
                ],
              },
              period: {
                '``': {
                  '@$': 'focusedRange',
                },
              },
              target: 'dim::!org',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      mtdcAvg: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcInLastThreeYears',
                                      ],
                                    },
                                  ],
                                },
                              },
                              3,
                            ],
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'projects',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'sqft',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdcDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        1,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'projects',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdc',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                              ],
                              {
                                '/': [
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'tdc',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      1,
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                      mtdcDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        1,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'projects',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdc',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                              ],
                              {
                                '/': [
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'mtdc',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      1,
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'sqft',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      mtdcAvgDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        1,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'projects',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdc',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                              ],
                              {
                                '/': [
                                  {
                                    '??': [
                                      {
                                        '/': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projects',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'mtdcInLastThreeYears',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          3,
                                        ],
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      1,
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  overflowActions: {
                    '[]': [
                      {
                        '{}': {
                          icon: 'atn-icon atn-link',
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          orgEntityId: {
                                            '@_': 'id',
                                          },
                                          orgRecordId: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'explore',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              subqueries: {
                rooms: {
                  ref: {
                    attr: 'attr:ent#!org_space#!entry:!space',
                  },
                  using: 'orgSpace',
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceEntityId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@^': {
                                  '``': {
                                    '@$': 'spaceEntityId',
                                  },
                                },
                              },
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'spaceType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': [
                                  '!space_use',
                                  {
                                    ref: {
                                      entity: '!group',
                                    },
                                  },
                                ],
                              },
                              {
                                '@>': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  'ent:!space_use:!group',
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'pis',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!space:!room',
                  selection: {
                    '{}': {
                      asf: {
                        '*': [
                          {
                            '@.': '!sqft',
                          },
                          {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'weights',
                                    },
                                    {
                                      '*': [
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'value',
                                          ],
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'allowable',
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'weights',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'value',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                      sqft: {
                        '@.': '!sqft',
                      },
                    },
                  },
                  subqueries: {
                    pis: {
                      ref: {
                        attr: 'attr:ent#!person_space#!entry:!space',
                        inherit: '-',
                      },
                      filter: {
                        '=': [
                          {
                            '@.': [
                              '!personnel',
                              {
                                ref: {
                                  entity: '!employee',
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                        ],
                      },
                      target: 'ent:!person_space:!entry',
                      selection: {
                        '@.': [
                          '!personnel',
                          {
                            ref: {
                              entity: '!employee',
                            },
                          },
                        ],
                      },
                    },
                    weights: {
                      ref: {
                        attr: 'attr:ent#!space_funcl#!entry:!space',
                        inherit: '-',
                      },
                      filter: {
                        '!=': [
                          {
                            '@.': '!weight',
                          },
                          0,
                        ],
                      },
                      target: 'ent:!space_funcl:!entry',
                      selection: {
                        '{}': {
                          value: {
                            '@.': '!weight',
                          },
                          allowable: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '@': 'funcIdCat',
                                    },
                                    null,
                                  ],
                                },
                                1,
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        funcIdCat: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!func_space',
                          },
                          target: 'ent:!func_space:!func',
                          selection: {
                            '@.': [
                              '!func_idc',
                              {
                                ref: {
                                  entity: '!cat',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
                orgSpace: {
                  ref: {
                    attr: 'attr:ent#!org_space#!entry:!org',
                    inherit: '-',
                  },
                  target: 'ent:!org_space:!entry',
                },
                projects: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!org',
                    inherit: '-',
                  },
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': '!research_type_wfuhs',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        not: {
                          '=': [
                            {
                              '@': 'projectPiAssignments',
                            },
                            null,
                          ],
                        },
                      },
                    ],
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '{}': {
                      tdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'tdcAmount',
                              ],
                            },
                          ],
                        },
                      },
                      mtdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'mtdcAmount',
                              ],
                            },
                          ],
                        },
                      },
                      mtdcInLastThreeYears: {
                        '+': {
                          '@': 'projectGlExpensesInMtdcInLastThreeYears',
                        },
                      },
                    },
                  },
                  subqueries: {
                    projectGlExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          tdcAmount: {
                            '@.': '!amount',
                          },
                          idcrAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@.': [
                                        '!acct',
                                        {
                                          ref: {
                                            entity: '!acct',
                                          },
                                        },
                                      ],
                                    },
                                    '?7631013',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          mtdcAmount: {
                            if: [
                              [
                                {
                                  '@': 'isInMtdc',
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      filter: {
                        and: [
                          {
                            not: {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'piRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              {
                                '@.': [
                                  '!pi',
                                  {
                                    ref: {
                                      entity: '!employee',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                    projectPiDepartments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      target: 'ent:!proj_pis:!entry',
                      selection: {
                        '@': 'piDept',
                      },
                      subqueries: {
                        piDept: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!pi',
                          },
                          target: 'ent:!personnel:!employee',
                          selection: {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: '!dept',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                    projectGlExpensesInMtdcInLastThreeYears: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      filter: {
                        '@': 'isInMtdc',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2024',
                          },
                          start: {
                            $date: '1/1/2022',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!org#!dept:!code',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!org#!dept:!name',
                        },
                      },
                    },
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'spaceRecordId',
                        },
                        null,
                      ],
                    },
                    {
                      '[]': [
                        {
                          '{}': {
                            id: 'tdc',
                            direct: {
                              '{}': {
                                name: 'TDC',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'tdcDensity',
                            direct: {
                              '{}': {
                                name: 'TDC Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdc',
                            direct: {
                              '{}': {
                                name: 'MTDC',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcDensity',
                            direct: {
                              '{}': {
                                name: 'MTDC Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcAvg',
                            direct: {
                              '{}': {
                                name: 'MTDC Average',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcAvgDensity',
                            direct: {
                              '{}': {
                                name: 'MTDC Average Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'asf',
                            direct: {
                              '{}': {
                                name: 'ASF',
                                type: 'INT',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'projects',
                            direct: {
                              '{}': {
                                name: 'Projects',
                                type: 'INT',
                              },
                            },
                          },
                        },
                      ],
                    },
                  ],
                  {
                    '[]': [
                      {
                        '{}': {
                          id: 'asf',
                          direct: {
                            '{}': {
                              name: 'ASF',
                              type: 'INT',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'totalSqft',
                          direct: {
                            '{}': {
                              name: 'Total Area',
                              type: 'INT',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'utilization',
                          direct: {
                            '{}': {
                              name: 'Utilization',
                              type: 'PERCENT',
                            },
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      mtdcAvg: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcInLastThreeYears',
                                      ],
                                    },
                                  ],
                                },
                              },
                              3,
                            ],
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'projects',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'totalSqft',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      mtdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'utilization',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                      mtdcAvgDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'records',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdcInLastThreeYears',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  3,
                                ],
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'mtdc',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'mtdc',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '=': [
                          {
                            '@_': ['parent', 'id'],
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'orgEntityId',
                              },
                            },
                          },
                        ],
                      },
                      {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      {
                        not: {
                          '=': [
                            {
                              '@': 'projects',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        not: {
                          '=': [
                            {
                              '@': 'rooms',
                            },
                            null,
                          ],
                        },
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'asf',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'asf',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '<=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'shouldAnalyze',
                                  },
                                },
                                true,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '@.': '!should_analyze',
                                },
                                true,
                              ],
                            },
                          ],
                          true,
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'dim::!org',
                  selection: {
                    '{}': {
                      asf: {
                        '+': {
                          '->': [
                            {
                              '@': 'rooms',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'asf',
                              ],
                            },
                          ],
                        },
                      },
                      tdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projects',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'tdc',
                              ],
                            },
                          ],
                        },
                      },
                      mtdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projects',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'mtdc',
                              ],
                            },
                          ],
                        },
                      },
                      projects: {
                        '??': [
                          {
                            '#': {
                              '@': 'projects',
                            },
                          },
                          0,
                        ],
                      },
                      totalSqft: {
                        '+': {
                          '->': [
                            {
                              '@': 'rooms',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'sqft',
                              ],
                            },
                          ],
                        },
                      },
                      tdcDensity: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    1,
                                  ],
                                },
                                0,
                              ],
                            },
                            {
                              '??': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'projects',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'tdc',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                          ],
                          {
                            '/': [
                              {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  1,
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      mtdcDensity: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    1,
                                  ],
                                },
                                0,
                              ],
                            },
                            {
                              '??': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'projects',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'mtdc',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                          ],
                          {
                            '/': [
                              {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  1,
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      utilization: {
                        '/': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'sqft',
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                      mtdcAvgDensity: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    1,
                                  ],
                                },
                                0,
                              ],
                            },
                            {
                              '??': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'projects',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'mtdc',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                          ],
                          {
                            '/': [
                              {
                                '??': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'mtdcInLastThreeYears',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      3,
                                    ],
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  1,
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      overflowActions: {
                        '[]': [
                          {
                            '{}': {
                              icon: 'atn-icon atn-link',
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              orgEntityId: {
                                                '@_': 'id',
                                              },
                                              orgRecordId: {
                                                '@.': '!id',
                                              },
                                            },
                                          },
                                          navigationId: 'explore',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        ],
                      },
                      mtdcInLastThreeYears: {
                        '+': {
                          '->': [
                            {
                              '@': 'projects',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'mtdcInLastThreeYears',
                              ],
                            },
                          ],
                        },
                      },
                    },
                  },
                  subqueries: {
                    rooms: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                      },
                      using: 'orgSpace',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '@^': {
                                      '``': {
                                        '@$': 'spaceEntityId',
                                      },
                                    },
                                  },
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '{}': {
                          asf: {
                            '*': [
                              {
                                '@.': '!sqft',
                              },
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '*': [
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'value',
                                              ],
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'allowable',
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'value',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          sqft: {
                            '@.': '!sqft',
                          },
                        },
                      },
                      subqueries: {
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            '!=': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '{}': {
                              value: {
                                '@.': '!weight',
                              },
                              allowable: {
                                if: [
                                  [
                                    {
                                      '!=': [
                                        {
                                          '@': 'funcIdCat',
                                        },
                                        null,
                                      ],
                                    },
                                    1,
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            funcIdCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    orgSpace: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!org',
                        inherit: '-',
                      },
                      target: 'ent:!org_space:!entry',
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!org',
                        inherit: '-',
                      },
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': '!research_type_wfuhs',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            not: {
                              '=': [
                                {
                                  '@': 'projectPiAssignments',
                                },
                                null,
                              ],
                            },
                          },
                        ],
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '{}': {
                          tdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          mtdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          mtdcInLastThreeYears: {
                            '+': {
                              '@': 'projectGlExpensesInMtdcInLastThreeYears',
                            },
                          },
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              tdcAmount: {
                                '@.': '!amount',
                              },
                              idcrAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@.': [
                                            '!acct',
                                            {
                                              ref: {
                                                entity: '!acct',
                                              },
                                            },
                                          ],
                                        },
                                        '?7631013',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '@': 'isInMtdc',
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                          },
                        },
                        projectPiAssignments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          filter: {
                            and: [
                              {
                                not: {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'piRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'piRecordId',
                                    },
                                  },
                                  {
                                    '@.': [
                                      '!pi',
                                      {
                                        ref: {
                                          entity: '!employee',
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          target: 'ent:!proj_pis:!entry',
                        },
                        projectPiDepartments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          target: 'ent:!proj_pis:!entry',
                          selection: {
                            '@': 'piDept',
                          },
                          subqueries: {
                            piDept: {
                              ref: {
                                attr: 'attr:ent#!proj_pis#!entry:!pi',
                              },
                              target: 'ent:!personnel:!employee',
                              selection: {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: '!dept',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                        projectGlExpensesInMtdcInLastThreeYears: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          filter: {
                            '@': 'isInMtdc',
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2024',
                              },
                              start: {
                                $date: '1/1/2022',
                              },
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
    researchType: ['BASIC RESEARCH'],
    shouldAnalyze: true,
  },
}
